module.exports = {"events_search":{"title":["<span>Explorer</span> les compagnies","<span>Discover</span> the companies"],"button_filter":["Filtrer","Filter"],"type_evenement":["Type d'événement","Event type"],"public":["Public","Target audience"],"item_all":["Tous","All"],"item_all_levels":["Tous niveaux","All levels"],"trouver_evenement":["Trouvez un événement","Find an event"],"afficher_resultats":["Afficher les résultats","Display results"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Events/translations/translations_events_search.json
// module id = 1494
// module chunks = 0